import { render, staticRenderFns } from "./type23.vue?vue&type=template&id=752ca265&scoped=true"
import script from "./type23.vue?vue&type=script&lang=js"
export * from "./type23.vue?vue&type=script&lang=js"
import style0 from "./type23.vue?vue&type=style&index=0&id=752ca265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752ca265",
  null
  
)

export default component.exports